"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupRoomsByTypeAndBoard = void 0;
const groupRoomsByTypeAndBoard = (rooms) => {
    const grouped = rooms.reduce((acc, room) => {
        const key = `${room.room.name.en}-${room.board}`;
        const images = room.room.images ? JSON.parse(room.room.images) : [];
        if (!acc[key]) {
            acc[key] = {
                images: [],
                name: `${room.room.name.en} (${room.board})`,
                quantity: 0,
                occupancy: 0,
                extra_beds: 0,
            };
        }
        acc[key].images = images;
        acc[key].quantity += 1;
        acc[key].occupancy += room.occupancy;
        acc[key].extra_beds += room.extra_bed ? 1 : 0;
        return acc;
    }, {});
    return Object.values(grouped);
};
exports.groupRoomsByTypeAndBoard = groupRoomsByTypeAndBoard;
